const baseplugin = {
  install(app) {
    // Funktion definieren
    const updateDocumentHead = (siteTitle, description) => {
      document.title = siteTitle;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", description);
      }
    };

    // Als globale Eigenschaft bereitstellen (für Options API)
    app.config.globalProperties.$updateDocumentHead = updateDocumentHead;
    
    // Als provider bereitstellen (für Composition API - empfohlen)
    app.provide('updateDocumentHead', updateDocumentHead);
    
    const logError = (error) => {
      console.error("LogError: ", error);
    };
    
    app.config.globalProperties.$logError = logError;
    app.provide('logError', logError);
    
    // Weitere Funktionen hier hinzufügen
  },
};

export default baseplugin;
